module.exports = __webpack_public_path__ + "img/active.a46bb3c8.png";